import React, { RefObject, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { setUser } from "../../state/creators";
import ContentLayout from "../../components/layout/contentLayout";
import About from "../../components/content/about";
import { extractGatewayHeaders } from "../_withAuth";
import { MeInterface, UserInterface } from "../../_types/user";
import Head from "next/head";
import { useRouter } from "next/router";
import { getCookie } from "cookies-next";
import { GetUserInformation } from "../../functions/helpers";
import { CheckAuthSession } from "../../functions/http-functions/auth";

const DOMAIN = process.env.DOMAIN;

type Props = {
	me: MeInterface | null;
	setUser: (user: UserInterface | null) => void;
};

const AboutPage = ({ me, setUser }: Props) => {
	const router = useRouter();

	useEffect(() => {
		if (me) {
			router.replace("/");
			return;
		}

		if (!me) {
			setUser(null);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [me]);

	const aboutRef: RefObject<HTMLDivElement> = useRef(null);

	const handleScrollToTarget = () => {
		if (aboutRef.current) {
			aboutRef.current.scrollIntoView({ behavior: "smooth" });
		}
	};

	return (
		<>
			<Head>
				<link rel="canonical" href="https://www.helloedun.co.uk/about" />
			</Head>
			<ContentLayout auth={me ? true : false} handleScrollToTarget={handleScrollToTarget}>
				<About ref={aboutRef} />
			</ContentLayout>
		</>
	);
};

export async function getServerSideProps(ctx: any) {
	ctx.res.setHeader("Cache-Control", "no-store");

	const gatewayHeaders = extractGatewayHeaders(ctx.req?.headers);
	if (gatewayHeaders) {
		return {
			redirect: {
				destination: "/",
				permanent: false,
			},
		};
	}

	const token = getCookie("token", ctx);
	if (!token) {
		return {
			props: {
				me: null,
			},
		};
	}

	try {
		const decodedToken = await GetUserInformation(token);
		await CheckAuthSession(token, {
			userId: decodedToken ? decodedToken.userId : "",
		});

		return {
			redirect: {
				destination: "/",
				permanent: false,
			},
		};
	} catch {
		ctx.res?.setHeader("Set-Cookie", [
			`preauthtoken=; expires="${new Date(0).toUTCString()}"; Max-Age=0; HttpOnly; path=/; secure; SameSite=None`,
			`token=; expires="${new Date(0).toUTCString()}"; Max-Age=0; HttpOnly; path=/; secure; SameSite=None; Domain=${DOMAIN}`,
		]);

		return {
			props: {
				me: null,
			},
		};
	}
}

const mapDispatchToProps = {
	setUser,
};

export default connect(null, mapDispatchToProps)(AboutPage);
